var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBloodDonation = function SvgBloodDonation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.125h18v11.017a2.483 2.483 0 0 1-2.483 2.483H7.483A2.483 2.483 0 0 1 5 21.142V10.125Z",
    fill: "#FED0C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.312 2.71c.417-.279.96-.279 1.377 0l9.4 6.266c1.022.681.54 2.274-.689 2.274H4.6c-1.228 0-1.71-1.593-.689-2.274l9.4-6.267Z",
    fill: "#FF6969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.517 13.5a.603.603 0 0 0-.603.603v1.647h-1.686a.603.603 0 0 0-.603.603v1.044c0 .333.27.603.603.603h1.686v1.685c0 .334.27.604.603.604h1.043c.334 0 .604-.27.604-.604V18h1.646c.334 0 .604-.27.604-.603v-1.044a.603.603 0 0 0-.604-.603h-1.646v-1.647a.603.603 0 0 0-.604-.603h-1.043Z",
    fill: "#FF6969"
  })));
};
export default SvgBloodDonation;